export const AuthType = {
    setAuth:'setAuth',
    setProfile:'setProfile',
    setAccessDashBoard:'setAccessDashBoard',
    setCallBackUrl:'setCallBackUrl',

  
      RESETAUTH: "RESETAUTH",
};